// extracted by mini-css-extract-plugin
module.exports = {"praise":"mWxWB42dyh8wuTvcobuRVA=="};